import React from "react";

const SuccessStories = () => {
  return <div>SuccessStories G D Goenka Darbhanga</div>;
};

export default SuccessStories;
